var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preservation-pay"},[_c('div',{staticClass:"preservation-main"},[_c('MyTitle',{attrs:{"theTitle":"交费"}}),_c('iframe',{attrs:{"src":_vm.payUrl}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }